import { render, staticRenderFns } from "./ContactTeamMenu.vue?vue&type=template&id=02ea6512&"
import script from "./ContactTeamMenu.vue?vue&type=script&lang=js&"
export * from "./ContactTeamMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02ea6512')) {
      api.createRecord('02ea6512', component.options)
    } else {
      api.reload('02ea6512', component.options)
    }
    module.hot.accept("./ContactTeamMenu.vue?vue&type=template&id=02ea6512&", function () {
      api.rerender('02ea6512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/sidebar/ContactTeamMenu.vue"
export default component.exports